import { useEffect, useMemo } from 'react';

const decodeString = (str) => decodeURIComponent(str);

const useIframeMessage = (baseOrigin, defaultPath) => {
  // Construct iframe URL with deep link restoration from ?url= param
  const iframeUrl = useMemo(() => {
    const { search } = window.location;
    const urlParamIndex = search.indexOf('url=');

    if (urlParamIndex !== -1) {
      // Deep link: use origin + full path from ?url= param
      const rawUrlParam = decodeString(search.slice(urlParamIndex + 4));
      const constructedUrl = baseOrigin + rawUrlParam;
      return constructedUrl.includes('iframe=true')
        ? constructedUrl
        : `${constructedUrl}${constructedUrl.includes('?') ? '&' : '?'}iframe=true`;
    }

    // Default: origin + default path with iframe=true
    return `${baseOrigin}${defaultPath}?iframe=true`;
  }, [baseOrigin, defaultPath]);

  // Listen for messages from iframe to update parent URL
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type === 'searchPageMsg' || event.data?.type === 'searchesPageMsg') {
        const { pathName } = event.data;

        if (pathName) {
          const url = new URL(`${window.location.origin}${window.location.pathname}`);
          url.searchParams.set('url', decodeString(pathName));
          window.history.pushState({}, '', decodeString(url.toString()));
        }
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return iframeUrl;
};

export default useIframeMessage;
